import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { WidgetModel } from '../../models/widget.model';
import { WidgetOptions } from 'common/contexts/useWidgetOptionsContext';

// identifier
export const ADD_TO_REPORT_SLICE_ID = 'addToReport';

interface AddToReportState {
  showModal: boolean;
  currentWidget: WidgetModel | null;
  currentChartOptions: WidgetOptions | null;
}

// default state
const initialState: AddToReportState = {
  showModal: false,
  currentWidget: null,
  currentChartOptions: null,
};

//slice
const addToReportSlice = createSlice({
  name: ADD_TO_REPORT_SLICE_ID,
  initialState,
  reducers: {
    toggleAddToReportModal: (state: AddToReportState, action: PayloadAction<boolean>) => {
      state.showModal = action.payload;
    },
    setCurrentWidget: (state: AddToReportState, action: PayloadAction<WidgetModel>) => {
      state.currentWidget = action.payload;
    },
    setCurrentChartOptions: (
      state: AddToReportState,
      action: PayloadAction<WidgetOptions | null>
    ) => {
      state.currentChartOptions = action.payload;
    },
    resetAddToReportModal: (state: AddToReportState) => {
      state.currentWidget = null;
      state.showModal = false;
    },
  },
});

//selectors
export const selectAddToReportCurrentWidget = (state: RootState) => state.addToReport.currentWidget;
export const selectAddToReportCurrentChartOptions = (state: RootState) =>
  state.addToReport.currentChartOptions ?? undefined;
export const selectAddToReportModalVisible = (state: RootState) => state.addToReport.showModal;

//actions
export const {
  toggleAddToReportModal,
  setCurrentWidget,
  setCurrentChartOptions,
  resetAddToReportModal,
} = addToReportSlice.actions;

//reducer
export default addToReportSlice;
